/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wallet_Card_Claims_SubmissionInputs */

const en_wallet_card_claims_submission = /** @type {(inputs: Wallet_Card_Claims_SubmissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claims Submission`)
};

const fr_wallet_card_claims_submission = /** @type {(inputs: Wallet_Card_Claims_SubmissionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soumission de réclamation`)
};

/**
* | output |
* | --- |
* | "Claims Submission" |
*
* @param {Wallet_Card_Claims_SubmissionInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const wallet_card_claims_submission = /** @type {((inputs?: Wallet_Card_Claims_SubmissionInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wallet_Card_Claims_SubmissionInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wallet_card_claims_submission(inputs)
	return fr_wallet_card_claims_submission(inputs)
});